import React from 'react';

/** The site's home page as lists show its address: "/" (or empty from analytics). */
export const isHomePath = (path: string | null | undefined) => path === '/' || path === '';

/**
 * "Home" beside the home page's title in every list that names it (backlog
 * 3495a4d1): its title is often just the site's name ("tinycms"), which says
 * nothing about it being the home page.
 */
export const HomeTag: React.FC<{ title?: string | null }> = ({ title }) =>
  titledHome(title) ? null : <span className="ink-home-tag">Home</span>;

/** A home page already titled "Home": the tag would only repeat it (backlog 0f01fd21). */
export const titledHome = (title: string | null | undefined) =>
  /^home$/i.test(String(title || '').trim());
